<!--COMMON HERO BANNER-->
<section class="hero-banner" [id]="id" [attr.data-beyond-hero-banner-id]="id">
  <div class="hero-background" [ngClass]="heroImageCss ? heroImageCss : ''">
    <div [ngClass]="gradientOverlayCss ? gradientOverlayCss : ''">
      <div class="wrapper" [ngClass]="displayCss ? displayCss : ''">
        <div [ngClass]="alignContentCss ? alignContentCss : ''">
          <!--HERO HEADING 1-->
          <span class="hero-heading">{{ name }}</span>
          <!--END HERO HENDING 1-->
          <!--HERO HEADING 2-->
          <h1
            *ngIf="showTitle"
            class="margin-top-small margin-bottom-small"
            [ngClass]="customHeadingCss ? customHeadingCss : ''">
            {{ title }}
          </h1>
          <!--END HERO HEADING 2-->
          <!--SUBHEADER PLACEHOLDER-->
          <ng-content select="[subHeader]"> </ng-content>
          <!--END SUBHEADER PLACEHOLDER-->
          <!--HERO DESCRIPTION-->
          <p
            *ngIf="description"
            class="margin-top-small margin-bottom-small"
            [ngClass]="customDescriptionCss ? customDescriptionCss : 'medium-text'"
            [innerHTML]="description | safe : 'html'"></p>
          <!--END HERO DESCRIPTION-->
          <!--CALL TO ACTION BUTTON-->
          <!--NOTE: Check routeType. Default is internal routes. The route with the slash searches for a route on the parent level -->
          <div *ngIf="showButton" class="card-actions">
            <!--CALL TO ACTION MESSAGE-->
            <ng-container *ngIf="showSubTitle && subTitle">
              <p class="bolder text-align-left margin-bottom-small">{{ subTitle }}</p>
            </ng-container>
            <!--END CALL TO ACTION MESSAGE-->
            <!--ROUTE BUTTON-->
            <app-route-button
              id="hero-banner-button-{{ id }}"
              [route]="route"
              [routeType]="routeType"
              [buttonRoute]="route"
              [queryParams]="queryParams"
              (buttonClick)="onClick($event)"
              [actionLabel]="actionLabel"
              [customButtonCss]="customButtonCss"
              [actionButtonCss]="'action-button'">
            </app-route-button>
            <!--END ROUTE BUTTON-->
          </div>
          <!--END CALL TO ACTION BUTTON-->
        </div>
        <!--NOTE: Allow ng-content or another block of elements to be projected into this banner-->
        <ng-content select="[content]"> </ng-content>
      </div>
    </div>
  </div>
</section>
<!--END COMMON HERO BANNER-->
